
const GuardrailsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Guardrails & Compliance
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Guardrails page provides governance and compliance controls for your AWS infrastructure.
          Define and enforce security policies, operational best practices, and regulatory requirements
          to maintain a secure and compliant cloud environment.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Compliance Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor overall compliance status across your AWS environments.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Compliance Score:</strong> Percentage of resources meeting policy requirements</li>
          <li><strong>Active Rules:</strong> Number of guardrails currently enforced</li>
          <li><strong>Violations:</strong> Resources not meeting compliance standards</li>
          <li><strong>Risk Level:</strong> Severity assessment of current violations</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Guardrail Rules
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Define and manage governance rules across different compliance domains.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Security Rules:</strong> Encryption, IAM policies, network controls</li>
          <li><strong>Cost Controls:</strong> Prevent costly resource types or regions</li>
          <li><strong>Operational Standards:</strong> Backup policies, monitoring requirements</li>
          <li><strong>Regulatory Compliance:</strong> HIPAA, SOC2, PCI-DSS requirements</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Policy Enforcement
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Control how guardrails are applied to your infrastructure.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Preventive Controls:</strong> Block non-compliant resources from being created</li>
          <li><strong>Detective Controls:</strong> Alert on policy violations after creation</li>
          <li><strong>Auto-Remediation:</strong> Automatically fix known compliance issues</li>
          <li><strong>Exception Management:</strong> Grant temporary exceptions to specific resources</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Violation Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track and resolve compliance violations across your environment.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Violation List:</strong> All resources not meeting compliance requirements</li>
          <li><strong>Severity Levels:</strong> Critical, High, Medium, Low priority violations</li>
          <li><strong>Resource Details:</strong> Specific information about non-compliant resources</li>
          <li><strong>Remediation Steps:</strong> Guided actions to fix violations</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Common Guardrails
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Pre-configured rules for common compliance scenarios.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Encryption at Rest:</strong> Require encryption for S3, RDS, EBS volumes</li>
          <li><strong>Public Access:</strong> Prevent public S3 buckets or security groups</li>
          <li><strong>MFA Requirements:</strong> Enforce multi-factor authentication for IAM</li>
          <li><strong>Region Restrictions:</strong> Limit resource creation to approved regions</li>
          <li><strong>Backup Policies:</strong> Ensure regular backups for critical resources</li>
          <li><strong>Logging Requirements:</strong> Mandate CloudTrail and VPC Flow Logs</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Compliance Reporting
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Generate reports for audits and compliance verification.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Compliance Reports:</strong> Export detailed compliance status for auditors</li>
          <li><strong>Historical Trends:</strong> Track compliance improvements over time</li>
          <li><strong>Account Breakdown:</strong> Compliance scores per AWS account</li>
          <li><strong>Remediation Tracking:</strong> Progress on fixing violations</li>
        </ul>
      </div>

    </>
  );
};

export default GuardrailsHelp;
